import { InfoTooltip, Stack, Typography } from '@cast/design-system';
import { RffSelect } from '@cast/shared-rff-ui';

type ConditionTooltipProps = {
  entity: string;
};

const ConditionTooltip = ({ entity }: ConditionTooltipProps) => {
  return (
    <Stack gap="1.5em">
      <Typography variant="P12R">
        <Typography variant="P12B" component="span">
          AND -{' '}
        </Typography>
        condition will be met when the {entity} has all the set labels.
      </Typography>
      <Typography variant="P12R">
        <Typography variant="P12B" component="span">
          OR -{' '}
        </Typography>
        condition will be met if at least one label is found on the {entity}.
      </Typography>
    </Stack>
  );
};

type LabelConditionSelectProps = {
  fieldName: string;
  entity: string;
};

export const LabelConditionSelect = ({
  fieldName,
  entity,
}: LabelConditionSelectProps) => {
  return (
    <RffSelect
      testId="labels-condition-select"
      prefix={
        <Stack gap={8} direction="row" alignItems="center">
          <InfoTooltip
            title={<ConditionTooltip entity={entity} />}
            iconSize="20px"
          />
          <Typography>Condition</Typography>
        </Stack>
      }
      name={fieldName}
      options={['OR', 'AND']}
      sx={{ width: 226 }}
      success={false}
    />
  );
};
